import userEpics from '../../user/epic/index';
import { combineEpics } from 'redux-observable';
import orderEpics from '../../order/epic/index';
import adminEpics from '../../admin/epic/index';
import estimationsEpics from '../../estimations/epic/index';
import productEpics from '../../products/epic/index';

export default combineEpics(userEpics, adminEpics, estimationsEpics, productEpics, orderEpics);



// WEBPACK FOOTER //
// ./src/application/core/epics/index.ts